/** @format */

import dot from 'dot-object';
import React from 'react';

const PHONE_REGEX = /^(\d{3})(\d{1,3})?(\d{1,4})?$/;
/**
 * A Higher Order Component for handling changes to individual items
 * Wrap a form with this to enable standardize changing of inputs
 */
export default ComponentContainer => {
    return class withChangeHandler extends React.Component {
        constructor(props) {
            super(props);
        }

        handleChange = (func, ...args) => {
            return this.props.onChange(func(...args));
        };

        render() {
            const props = {...this.props};

            props.onNumberInputChange = this.handleChange.bind(this, onNumberInputChange);
            props.onFloatNumberChange = this.handleChange.bind(this, onFloatNumberChange);
            props.onPhoneInputChange = this.handleChange.bind(this, onPhoneInputChange);
            props.onIntNumberChange = this.handleChange.bind(this, onIntNumberChange);
            props.onCheckboxChange = this.handleChange.bind(this, onCheckboxChange);
            props.onBooleanChange = this.handleChange.bind(this, onBooleanChange);
            props.onInputChange = this.handleChange.bind(this, onInputChange);
            props.onChangeBypass = this.props.onChange; // totally skip this hoc. Used when the child component already sets target
            props.onChange = this.handleChange.bind(this, onChange);

            return <ComponentContainer {...props} />;
        }
    };
};

const createListTargetUpdate = (list, id, field, value) => {
    const index = list.findIndex(item => item.id === id);
    // console.log('index', {[index]: {[field]: {$set: value}}});
    return {[index]: {[field]: {$set: value}}};
};

const onInputChange = (dotPath, e) => {
    let value = parseValue(e);

    // This is here for IE 11 because it does not respect
    // The type="number" at the time of writing
    if (e?.target && e.target.type === 'number') {
        value = value.replace(/[^0-9.]/g, '');
    }

    return onChange(dotPath, value);
};

const onNumberInputChange = (dotPath, e) => {
    let value = parseValue(e);
    value = parseNumberValue(value);
    return onChange(dotPath, value);
};

const onIntNumberChange = (dotPath, e) => {
    let value = parseValue(e);
    value = parseIntValue(value);
    return onChange(dotPath, value);
};

const onFloatNumberChange = (dotPath, e) => {
    let value = parseValue(e);
    value = parseFloatValue(value);
    return onChange(dotPath, value);
};

const onBooleanChange = (dotPath, e) => {
    let value = parseValue(e);
    value = parseBooleanValue(value);
    return onChange(dotPath, value);
};

const onPhoneInputChange = (dotPath, e) => {
    let value = parseValue(e);
    value = parsePhoneValue(value);
    return onChange(dotPath, value);
};

const onCheckboxChange = (dotPath, e) => {
    let value = parseCheckboxValue(e);
    return onChange(dotPath, value);
};

const onChange = (dotPath, value) => {
    const target = {};
    target[dotPath] = {$set: value};
    return dot.object(target);
};

const parseValue = e => {
    return typeof e?.target?.value !== 'undefined' ? e.target.value : e;
};

const parseCheckboxValue = e => {
    return typeof e.target !== 'undefined' && typeof e.target.checked !== 'undefined'
        ? e.target.checked
            ? true
            : false
        : parseBooleanValue(e);
};

const parsePhoneValue = value => {
    value = value.replace(/[^0-9.]/g, '');
    const matches = value.match(PHONE_REGEX);
    const formattedPhone = [];
    if (matches) {
        matches.splice(0, 1);
        matches.forEach(match => {
            if (match) {
                formattedPhone.push(match);
            }
        });
        value = formattedPhone.join('-');
    }
    return value;
};

const parseFloatValue = value => {
    value = value.toString().replace(/[^0-9.]/g, '');
    value = parseFloat(value);
    if (isNaN(value)) {
        value = null;
    }
    return value;
};

const parseIntValue = value => {
    value = value.toString().replace(/[^0-9.]/g, '');
    value = parseInt(value);
    if (isNaN(value)) {
        value = null;
    }
    return value;
};

const parseNumberValue = value => {
    return value.toString().replace(/[^0-9.]/g, '');
};

const parseBooleanValue = value => {
    return value === true ? true : false;
};

export {
    onInputChange,
    onNumberInputChange,
    onIntNumberChange,
    onFloatNumberChange,
    onBooleanChange,
    onPhoneInputChange,
    onCheckboxChange,
    onChange,
    parseCheckboxValue,
    parseValue,
    parsePhoneValue,
    parseFloatValue,
    parseIntValue,
    parseNumberValue,
    parseBooleanValue,
    createListTargetUpdate
};
